import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';

import { PLACEHOLDER_IMAGE } from 'constants/shop';
import LazyImage from 'shared/LazyImage';
import { trackEvent } from 'utils/analyticsUtils';
import { getPercentOffOriginalPrice, getProductOriginalPrice } from 'utils/productUtils';

function AssortmentProductCard({ aisle, item, lazyImage }) {
    const percentOff = getPercentOffOriginalPrice(item);
    const originalPrice = getProductOriginalPrice(item);
    const isMango = window.location.pathname.includes('mango');
    const { pathname } = useLocation();

    const getClickLocation = () => {
        if (pathname === '/grocery-and-produce-delivery-sneak-peek') return 'grocery preview page';
        return isMango ? 'home page' : 'lead capture page';
    };

    const onProductCardClick = () => {
        // this localstorage val is used for scroll-to behavior when going between mango homepage and boysenberry pages. no need to set value for pages outside of mango homepage.
        localStorage.setItem('prevPath', isMango ? 'home' : null);

        trackEvent('grocery preview product card clicked', {
            location: getClickLocation(),
            aisle,
            product_name: item?.name,
        });
    };

    return (
        <Link
            to={`/${item.slug}/p?redirect=true`}
            state={{ previousPath: pathname }}
            target={isMango ? '_top' : '_self'}
            className="mx-auto mb-20 min-h-[310px] min-w-[150px] max-w-[170px] p-5"
            onClick={onProductCardClick}
        >
            {lazyImage ? (
                <LazyImage
                    placeholderSrc={PLACEHOLDER_IMAGE}
                    src={item.photoMed || PLACEHOLDER_IMAGE}
                    alt={item.name}
                    className="w-[170px] rounded-lg"
                    height={170}
                    width={170}
                />
            ) : (
                <img
                    src={item.photoMed || PLACEHOLDER_IMAGE}
                    className="w-[170px] rounded-lg"
                    alt={item.name}
                    width={170}
                    height={170}
                />
            )}

            <div className="flex gap-10 pt-10">
                {originalPrice > item?.price && (
                    <p className="text-body-sm mt-[2px] line-through">${originalPrice.toFixed(2)}</p>
                )}
                {percentOff > 5 && (
                    <p className="text-body-sm text-brand-primary font-grotesk-bold">{percentOff}% off</p>
                )}
            </div>
            {item?.price && <p className="text-body-md font-grotesk-bold">${item.price.toFixed(2)}</p>}
            {item?.name && <p className="text-body-sm line-clamp-2">{item.name}</p>}
            {item?.sourcingReason && (
                <p className="text-body-sm mt-5 line-clamp-2 w-fit rounded-md bg-off-white px-5">
                    {item.sourcingReason}
                </p>
            )}
        </Link>
    );
}

AssortmentProductCard.propTypes = {
    aisle: PropTypes.string.isRequired,
    item: PropTypes.shape({
        msrp: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        photoMed: PropTypes.string.isRequired,
        portion: PropTypes.number.isRequired,
        price: PropTypes.number.isRequired,
        slug: PropTypes.string.isRequired,
        sourcingReason: PropTypes.string.isRequired,
    }).isRequired,
    lazyImage: PropTypes.bool,
};

AssortmentProductCard.defaultProps = {
    lazyImage: false,
};

export default AssortmentProductCard;
